module.exports = __webpack_public_path__ + "img/ukr.a8b13525.svg";